export default __webpack_public_path__ + "static/media/W_B_False.45e8ff0e.jpg";